/** A zone's configured color, else amber for staging and blue otherwise. */
export function zoneColor(zone: {
  configuration?: any;
  zone_type?: string | null;
}): string {
  return (
    zone.configuration?.color || (zone.zone_type === 'staging' ? '#F59E0B' : '#2196F3')
  );
}
